import { Popover } from 'antd';
import { omit } from 'lodash';

import { None } from 'components/data/helpers';
import * as inspectionData from 'components/data/inspections';
import type { AtlasGqlInspection } from 'types/atlas-graphql';
import { useAccountContext } from 'utils/account/AccountContext';
import { STANDARD_COLUMN_SCROLL_Y, TABLE_SCROLL_WIDTH_SMALL } from 'utils/constants';
import { INSPECTION_VENDOR_NAMES } from 'utils/release-toggles';

import { StyledPopoverTable } from './Popovers.style';

type InspectionsPopoverTableProps = {
  inspections: AtlasGqlInspection[];
};

export const InspectionsPopoverTable: React.FunctionComponent<InspectionsPopoverTableProps> = ({
  inspections,
}) => {
  const { hasReleaseToggle } = useAccountContext();

  return inspections.length ? (
    <Popover
      content={
        <StyledPopoverTable
          data-testid="inspections-popover-table"
          columns={[
            { ...inspectionData.date, defaultSortOrder: 'descend' },
            inspectionData.type,
            omit(inspectionData.getVendorColumn(hasReleaseToggle(INSPECTION_VENDOR_NAMES)), [
              'filterDropdown',
              'filters',
              'onFilter',
            ]),
          ]}
          dataSource={inspections}
          size="small"
          rowKey="id"
          pagination={false}
          scroll={STANDARD_COLUMN_SCROLL_Y}
          style={{ width: TABLE_SCROLL_WIDTH_SMALL }}
        />
      }
    >
      {inspections.length}
    </Popover>
  ) : (
    <None />
  );
};
